import ReactDOM from 'react-dom';
import { useState, useEffect } from '@wordpress/element';
import EventBanner from './components/event-banner';
import Content from './navigation/content';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './navigation/navigation';
import { Helmet } from './helper/helmet/helmet';
import { CloseButtonSVG } from "./icon";
import { closeBanner } from "./helper/axios";
import '../shared/modal-host';

const isProActive = () => {
    return !!window['JkitDashboardOption']?.proActive;
};

if (document.getElementById('jkit-admin-dashboard')) {
    const loadContent = () => {
        const {
            bannerData,
        } = window['JkitDashboardOption'] || {};
        const App = () => {

            useEffect(() => {
                const onClick = (e) => {
                    const el = e.target.closest && e.target.closest('a.upgrade, .button-upgrade-pro, .button-upgrade, .upgrade-pro-btn, .jkit-upgrade-to-pro-menu a, #wp-admin-bar-jeg-kit-pro, #jkit-onboard-wizard .upgrade-pro-button, #jkit-onboard-wizard .f-button-upgrade, .jkit-upgrade-popup .upgrade-pro-button');
                    if (isProActive() && el?.matches('.jkit-upgrade-popup .upgrade-pro-button')) return;

                    if (el) {
                        try {
                            e.preventDefault();
                            e.stopPropagation();
                            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
                        } catch (err) {
                            // ignore
                        }
                        if (typeof window.JkitOpenPricingModal === 'function') {
                            window.JkitOpenPricingModal();
                        }
                    }
                };
                // Use capture so we intercept navigation before other listeners
                document.addEventListener('click', onClick, true);
                // also prevent middle-click / auxclick from opening new tab
                document.addEventListener('auxclick', onClick, true);
                return () => {
                    document.removeEventListener('click', onClick, true);
                    document.removeEventListener('auxclick', onClick, true);
                };
            }, []);

            return (
                <div className="jeg-elementor-kit-dashboard" >
                    <Helmet>
                        <link rel="preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
                    </Helmet>
                    <Navigation />
                    <EventBanner bannerData={bannerData} />
                    <Routes>
                        <Route path="*" element={<Content />} />
                    </Routes>
                </div>
            );
        };

        try {
            const container = document.getElementById('jkit-admin-dashboard');
            if (ReactDOM && typeof ReactDOM.createRoot === 'function') {
                ReactDOM.createRoot(container).render(
                    <Router>
                        <App />
                    </Router>
                );
            } else {
                ReactDOM.render(
                    <Router>
                        <App />
                    </Router>,
                    container
                );
            }
        } catch (e) {
            // fallback to legacy render if anything goes wrong
            ReactDOM.render(
                <Router>
                    <App />
                </Router>,
                document.getElementById('jkit-admin-dashboard')
            );
        }
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        loadContent();
    } else {
        window.addEventListener('load', () => {
            loadContent();
        })
    }
}
